export const getTranslations = (array, lang, fallbackLang) => {
  if (!Array.isArray(array)) return {};
  return (
    array.find((item) => item.lang === lang) ||
    array.find((item) => item.lang === fallbackLang) ||
    {}
  );
};

const CURRENCY_SYMBOLS = {
  ILS: "₪",
  USD: "$",
  EUR: "€",
  GBP: "£",
};

export const getCurrencySymbol = (currency) => {
  return CURRENCY_SYMBOLS[currency] || currency || "$";
};

export const getTipValue = (amount, tip) => {
  return (amount * tip) / 100;
};

export const calculateActualAmount = (items) => {
  return items && items.length > 0
    ? items.map((data) => data?.price).reduce((acc, value) => acc + value, 0)
    : 0;
};

export const getOrderSummary = (items, prevSummary = {}) => {
  const actual_amount = calculateActualAmount(items);
  const tip = prevSummary.tip || 15;
  const paid = prevSummary.paid || 0;
  const tipValue = getTipValue(actual_amount, tip);
  return {
    paid,
    tip,
    actual_amount,
    total_amount: actual_amount + tipValue,
  };
};

/** Formats an amount for display: whole amounts without decimals (48), others with two (48.50). */
export const getPrice = (value) => {
  if (typeof value !== "number" || isNaN(value)) return "0";
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? `${rounded}` : rounded.toFixed(2);
};
